"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Typography = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Typography = ({
  className,
  text,
  typographyVariant,
  color,
  colorVariant,
  ...rest
}) => {
  const baseTypographyClass = "sp-typography";
  let typographyClasses = [className, `${baseTypographyClass}-${typographyVariant}`];
  const baseColorClass = "sp-text-color";
  let colorClasses = [`${baseColorClass}--${color}${colorVariant ? `-${colorVariant}` : ""}`];
  let classes = (0, _classnames.default)(typographyClasses, colorClasses);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, rest), text);
};

exports.Typography = Typography;
Typography.defaultProps = {
  typographyVariant: "disp-heading"
};
Typography.propTypes = {
  className: _propTypes.default.string,
  text: _propTypes.default.string,
  typographyVariant: _propTypes.default.oneOf(_utils.enums.TypographyVariants),
  color: _propTypes.default.oneOf(_utils.enums.colors),
  colorVariant: _propTypes.default.oneOf(_utils.enums.colorVariants)
};
var _default = Typography;
exports.default = _default;